import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('Plantsp?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('Plantsp/show/'+id);
    },    
    create(params) {
        return Service().post('Plantsp/create', params);
    },
    update(id, params) {
        return Service().post('Plantsp/update/'+id, params);
    },
    delete(id) {
        return Service().post('Plantsp/delete/'+id);
    }
}